// removed by extract-text-webpack-plugin
module.exports = {"resourceView":"styles__resourceView___13-4s","visitSite":"styles__visitSite___13RNG","rotate":"styles__rotate___2f1id","fadein":"styles__fadein___2Gtbs","slideFromRight":"styles__slideFromRight___14qtu","waves":"styles__waves___242Wl"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/ResourceView/styles.scss
// module id = ./resources/assets/js/components/ResourceView/styles.scss
// module chunks = 0